import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Sun, Lightning, BatteryCharging, PencilSimple } from '@phosphor-icons/react';

export function ImpiantoSection({ impianto, onEdit }) {
    return (
        <Card>
            <CardHeader className="pb-3">
                <div className="flex items-center justify-between">
                    <CardTitle className="flex items-center gap-2 text-base">
                        <Sun className="w-5 h-5 text-primary" />
                        Dati Impianto
                        {impianto?.potenza_nominale_kwp && (
                            <Badge className="ml-2 bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-200">
                                {impianto.potenza_nominale_kwp} kWp
                            </Badge>
                        )}
                    </CardTitle>
                    <Button variant="ghost" size="sm" onClick={onEdit} data-testid="edit-impianto-btn">
                        <PencilSimple className="w-4 h-4" />
                    </Button>
                </div>
            </CardHeader>
            <CardContent className="space-y-4">
                {/* Moduli */}
                <div className="p-3 bg-muted/50 rounded-lg">
                    <p className="text-xs text-muted-foreground mb-2 flex items-center gap-1">
                        <Sun className="w-3 h-3" /> Moduli Fotovoltaici
                    </p>
                    <div className="grid grid-cols-2 gap-2 text-sm">
                        <div>
                            <span className="text-muted-foreground">Quantità:</span> {impianto?.numero_moduli || '-'}
                        </div>
                        <div>
                            <span className="text-muted-foreground">Marca:</span> {impianto?.moduli_marca || '-'}
                        </div>
                        {impianto?.moduli_modello && (
                            <div className="col-span-2">
                                <span className="text-muted-foreground">Modello:</span> {impianto.moduli_modello}
                            </div>
                        )}
                    </div>
                </div>

                {/* Inverter */}
                <div className="p-3 bg-muted/50 rounded-lg">
                    <p className="text-xs text-muted-foreground mb-2 flex items-center gap-1">
                        <Lightning className="w-3 h-3" /> Inverter
                    </p>
                    <div className="grid grid-cols-2 gap-2 text-sm">
                        <div>
                            <span className="text-muted-foreground">Quantità:</span> {impianto?.numero_inverter || '-'}
                        </div>
                        <div>
                            <span className="text-muted-foreground">Marca:</span> {impianto?.inverter_marca || '-'}
                        </div>
                        {impianto?.inverter_modello && (
                            <div className="col-span-2">
                                <span className="text-muted-foreground">Modello:</span> {impianto.inverter_modello}
                            </div>
                        )}
                    </div>
                </div>

                {/* Sistema di Accumulo */}
                {impianto?.accumulo_presente && (
                    <div className="p-3 bg-green-50 dark:bg-green-950/30 rounded-lg border border-green-200 dark:border-green-800">
                        <p className="text-xs text-green-700 dark:text-green-400 mb-2 flex items-center gap-1">
                            <BatteryCharging className="w-3 h-3" /> Sistema di Accumulo
                        </p>
                        <div className="grid grid-cols-2 gap-2 text-sm">
                            <div>
                                <span className="text-muted-foreground">Capacità:</span> {impianto.batteria_capacita_kwh ? `${impianto.batteria_capacita_kwh} kWh` : '-'}
                            </div>
                            <div>
                                <span className="text-muted-foreground">Marca:</span> {impianto.batteria_marca || '-'}
                            </div>
                            {impianto.batteria_modello && (
                                <div className="col-span-2">
                                    <span className="text-muted-foreground">Modello:</span> {impianto.batteria_modello}
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {/* Installazione */}
                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <p className="text-xs text-muted-foreground">Tipo Installazione</p>
                        <p className="text-sm capitalize">{impianto?.tipo_installazione?.replace('_', ' ') || '-'}</p>
                    </div>
                    <div>
                        <p className="text-xs text-muted-foreground">Orientamento</p>
                        <p className="text-sm capitalize">{impianto?.orientamento || '-'}</p>
                    </div>
                </div>

                {/* Producibilità */}
                {impianto?.producibilita_stimata_kwh_anno && (
                    <div className="p-3 bg-primary/10 rounded-lg">
                        <p className="text-xs text-muted-foreground">Producibilità Stimata</p>
                        <p className="text-lg font-semibold text-primary">
                            {impianto.producibilita_stimata_kwh_anno.toLocaleString()} kWh/anno
                        </p>
                    </div>
                )}
            </CardContent>
        </Card>
    );
}
